import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssignedParkingDTO, CompanySubsidy, SubsidyDTO } from '../models/subsidy';
import { AppConfigService } from './shared-services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SubsidyService {
  apiName = 'subsidyService';
  subsidyData$!: Observable<SubsidyDTO[]>;
  constructor(private http: HttpClient) {}

  getSubsidyData(idMember: string): Observable<SubsidyDTO[]> {
    let url = AppConfigService.apiURL(this.apiName) + '/Subsidy/{idMember}';
    url = url.replace('{idMember}', idMember);
    return this.http.get<SubsidyDTO[]>(url);
  }
  getCompanySubsidy(idCompany: string): Observable<CompanySubsidy[]> {
    let url = AppConfigService.apiURL(this.apiName) + '/subsidy/bycompany/{idCompany}';
    url = url.replace('{idCompany}', idCompany);
    return this.http.get<CompanySubsidy[]>(url);
  }
  getSubsidyBalance(idMember): Observable<number> {
    let url_ = AppConfigService.apiURL(this.apiName) + '/subsidy/getsubsidybalancebyidmember';
    if (idMember) {
      url_ = url_ + '?IdMember=' + idMember;
    }
    return this.http.get<number>(url_);
  }
  getHasAssignedParking(idMember): Observable<boolean> {
    let url_ = AppConfigService.apiURL(this.apiName) + '/subsidy/hasassignedparking';
    if (idMember) {
      url_ = url_ + '?IdMember=' + idMember;
    }
    return this.http.get<boolean>(url_);
  }
  getAssignedParking(idMember): Observable<AssignedParkingDTO[]> {
    let url_ = AppConfigService.apiURL(this.apiName) + '/subsidy/assignedparking';
    if (idMember) {
      url_ = url_ + '?IdMember=' + idMember;
    }
    return this.http.get<AssignedParkingDTO[]>(url_);
  }
  getAssignedParkingUI(idMember): Observable<AssignedParkingDTO[]> {
    let url_ = AppConfigService.apiURL(this.apiName) + '/subsidy/assignedparkingui';
    if (idMember) {
      url_ = url_ + '?IdMember=' + idMember;
    }
    return this.http.get<AssignedParkingDTO[]>(url_);
  }
}
